import React, { Component } from "react";
import {
  Col,
  Button,
  Input,
  InputNumber,
  message,
  Modal,
  notification,
  Radio,
  Row,
  Select,
  Table,
  Icon,
  Spin,
  Card,
} from "antd";
import { Controller } from "Controller/Controller";
import CreateMember from "./CreateMember";
import { BsClockHistory } from "react-icons/bs";
import { Alert } from "components/Alert/Alert";
import Payment from "views/paymentAdmin/pay";
import App from "views/payment/stripe/AppSingle";
import PaymentForm from "views/payment/stripe/PaymentForm";
import MemberCardsCarousel from "./select-cards-carousel/MemberCardsCarousel";
import { controller } from "../../../../../src/views/payment/stripe/controller";
import Success from "views/payment/stripe/Success";
import SuccessPage from "views/paymentAdmin/component/SuccessPage";

const { Search } = Input;
const { TextArea } = Input;
const { Option } = Select;

const Config = {
  headers: {
    Authorization: localStorage.getItem("user")
      ? "Token " + JSON.parse(localStorage.getItem("user")).key
      : "",
  },
};

const props = {
  name: "file",
  action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
  headers: {
    authorization: "authorization-text",
  },
  onChange(info) {
    if (info.file.status !== "uploading") {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === "done") {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};

const serviceColumns = [
  /*{
    title: 'Id',
    dataIndex: 'Id',
    render: text => <a>{text}</a>,
  },*/
  {
    title: "Name",
    dataIndex: "Name",
    render: (text) => <a>{text}</a>,
  },
  {
    title: "Count",
    dataIndex: "Count",
    render: (text) => <a>{text}</a>,
  },
  /*  {
      title: 'Price',
      dataIndex: 'Price',
      render: text => <a>{text}</a>,
    },*/
  {
    title: "Action",
    dataIndex: "Action",
    render: (text) => <a>{text}</a>,
  },
];

class CreatePlan extends Component {
  openNotification = (placement, message, status) => {
    notification.info({
      message: status,
      description: message,
      placement,
    });
  };

  getPlan = async () => {
    const response = await Controller.GetAllPlans();
    this.setState({
      planList: response.json,
    });
  };

  getCycle = async () => {
    const response = await Controller.getCycles();
    console.log("response.json");
    console.log(response.json);
    this.setState({
      Cycle: response.json,
    });
  };

  getMember = async () => {
    const response = await Controller.GetAllMember();
    const responseBusinessMember = await Controller.readBusinessMember(1);

    console.log("response.json");
    console.log(response);
    console.log(responseBusinessMember);
    this.setState({
      membersList: response.json,
      businessMemberList: responseBusinessMember.json,
    });
  };

  handleCloseMember = () => {
    this.setState({
      openCreateMember: false,
    });
  };

  handleAddNewMember = (id) => {
    console.log(id);
    this.getMember();

    this.setState({
      newCustomerid: id,
      openCreateMember: false,
    });
  };

  handleAddMember = () => {
    this.setState({
      openCreateMember: true,
    });
  };

  getData = () => {
    // get billing cycle
    this.getCycle();

    //Get member list
    this.getMember();

    //Get Plan list
    this.getPlan();
  };

  checkURLforSuccessMessageOfPayNowOption = () => {
    if ((window.location.href + "").includes("redirect_status=succeeded")) {
      window.location.href =
        window.location.protocol +
        "//" +
        window.location.host +
        "#/admin/payment-admin-done/payid/" +
        sessionStorage.getItem("selectedPAYID") +
        "/";
    }
  };

  checkPrmission = async () => {
    const response = await Controller.checkConnectedAccount();
    if (!response.detail) {
      this.setState({
        permission: false,
      });
    } else if (!response.detail.is_verified) {
      this.setState({
        permission: false,
      });
    } else {
      this.setState({
        permission: true,
      });
    }
  };

  // Map radio values to interval strings
  mapRepeatTypeToInterval = (type) => {
    switch (type) {
      case "day":
        return "Daily";
      case "week":
        return "Weekly";
      case "month":
        return "Monthly";
      case "year":
        return "Annual";
      default:
        return "Monthly";
    }
  };

  // Handle count changes
  handleRepeatCountChange = (type, value) => {
    this.setState((prevState) => {
      const newCounts = {
        ...prevState.repeatCounts,
        [type]: value,
      };

      const newState = {
        repeatCounts: newCounts,
      };

      // Update createsService only if this is the active type
      if (prevState.repeatType === type) {
        newState.createsService = {
          ...prevState.createsService,
          interval_count: value,
        };
      }

      return newState;
    });
  };

  ensurePlanHasService = (services) => {
    if (!services || services.length === 0) {
      Alert.openNotification(
        "Please add at least one service before creating a plan.",
        "error"
      );
      return false;
    }
    return true;
  };

  constructor(props) {
    super(props);
    this.checkPrmission();
    this.getData();
    this.checkURLforSuccessMessageOfPayNowOption();

    this.state = {
      repeatCounts: {
        day: 1,
        week: 1,
        month: 1,
        year: 1,
      },
      paySinglePaymentState: false,
      selectedCardId: null,
      isPaid: false,
      transactionData: "",
      send_payment_request_email: true,
      payNowState: false,
      permission: "loading",
      loadingCreatePreDefined: false,
      newCustomerid: "",
      openCreateMember: false,
      membershipCreateDataCustom: {
        commitment_term: 1,
        membership: {
          customer: "",
          is_active: true,
          automatic_renewal: true,
        },
        membership_plan: {
          services: [],
          name: "",
          interval: "",
          //interval_count: 0,
          active: true,
          cost: "",
          description: "",
          type: "custom",
          terms: "",
        },
      },
      membershipCreateData: {
        commitment_term: 1,
        customer: "",
        plan: "",
        automatic_renewal: true,
      },
      singlePaymentData: {
        amount: "",
        customer: "",
      },

      changeStateTempForTestTableUpdate: true,
      showCreateServiceForm: false,
      SelectedServicesFromSelectBox: "",
      SelectedCountFromSelectBox: "",
      preDefinePlanForCreate: {
        name: "",
        interval: "",
        //interval_count: 0,
        cost: "",
        description: "",
        active: true,
        clinic: localStorage.getItem("selectedOffice"),
        type: "predefined",
        services: [
          /*{
            count: 0,
            service: 0
          }*/
        ],
        terms: "",
      },
      createsService: {
        name: "",
        description: "",
        cost: "",
      },
      NpServices: [
        {
          cost: "",
          description: "",
          id: 1,
          name: "",
        },
      ],
      openAddNewRowVisible: false,
      membersList: [],
      businessMemberList: [],
      Cycle: [],
      planList: [],
      visibleAddservice: false,
      selectedServices: [],
      currentState: "preDefinePlan", // 1. customePlan 2. preDefinePlan 3.createNewPlan
    };

    this.updateServiceList = this.updateServiceList.bind(this);
    this.handleCloseMember = this.handleCloseMember.bind(this);
    this.handleAddNewMember = this.handleAddNewMember.bind(this);
    this.handleCreateCustomPlan = this.handleCreateCustomPlan.bind(this);
    this.handleAddMember = this.handleAddMember.bind(this);
    this.getCycle = this.getCycle.bind(this);
    this.getData = this.getData.bind(this);
    this.getPlan = this.getPlan.bind(this);
    this.handleOpenAddService = this.handleOpenAddService.bind(this);
    this.handleCloseAddService = this.handleCloseAddService.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.addNewRow = this.addNewRow.bind(this);
    this.addNewRowModal = this.addNewRowModal.bind(this);
    this.handleCreateNewPlan = this.handleCreateNewPlan.bind(this);
    this.editService = this.editService.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCreateService = this.handleCreateService.bind(this);
    this.handleChangeCreatePlanData =
      this.handleChangeCreatePlanData.bind(this);
    this.handleCreateNewPlanPreDefined01 =
      this.handleCreateNewPlanPreDefined01.bind(this);
    //this.handleSelectMemberInModal = this.handleSelectMemberInModal.bind(this)
    this.handleSubmitCreateNewMembershipWithMemberAndPlan =
      this.handleSubmitCreateNewMembershipWithMemberAndPlan.bind(this);
  }
  updateServiceList = async () => {
    const response = await Controller.GetServiceNP(
      this.state.currentState !== "customePlan" ? "membership" : "installment"
    );

    this.setState({
      NpServices: response.json,
    });
  };
  handleCreateCustomPlan = async () => {
    console.log("ccccsdfccdd", this.state.membershipCreateDataCustom);
    const membershipCreateDataCustom = {
      ...this.state.membershipCreateDataCustom,
      send_payment_request_email: true,
    };

    if (
      !this.ensurePlanHasService(
        membershipCreateDataCustom?.membership_plan?.services
      )
    ) {
      return;
    }

    const response = await Controller.CreateCustomMembership(
      membershipCreateDataCustom
    );
    if (response.status < 250) {
      this.openNotification(
        "bottom",
        response.message ? response.message : "Done",
        "Successfull"
      );
      this.setState({
        membershipCreateDataCustom: {
          ...this.state.membershipCreateDataCustom,
          commitment_term: 1,
          membership_plan: {
            ...this.state.membershipCreateDataCustom.membership_plan,
            services: [],
            name: "",

            //interval_count: 0,
            active: true,
            cost: "",
            description: "",
            type: "custom",
            terms: "",
          },
        },
      });
    }
  };

  handleCardSelection = (cardInfo) => {
    this.setState({
      selectedCardId: cardInfo ? cardInfo.id : null,
    });
    console.log("Card selected in parent:", cardInfo ? cardInfo.id : null); // For testing
  };

  handleCreateCustomPlanPayNow = async () => {
    console.log("ccccccdd", this.state.membershipCreateDataCustom);

    const { membershipCreateDataCustom } = this.state;

    // Remove duration_* only when they're null
    const sanitizeServices = (services = []) =>
      services.map(({ duration_unit, duration_value, ...rest }) => ({
        ...rest,
        ...(duration_unit != null ? { duration_unit } : {}),
        ...(duration_value != null ? { duration_value } : {}),
      }));

    const payload = {
      ...membershipCreateDataCustom,
      send_payment_request_email: false,
      membership_plan: {
        ...membershipCreateDataCustom.membership_plan,
        services: sanitizeServices(
          membershipCreateDataCustom.membership_plan?.services
        ),
      },
    };

    if (!this.ensurePlanHasService(payload.membership_plan?.services)) {
      return;
    }

    const response = await Controller.CreateCustomMembership(payload);

    if (response.status < 250) {
      this.openNotification(
        "bottom",
        response.message ? response.message : "Done",
        "Successfull"
      );

      this.setState({
        membershipCreateDataCustom: {
          ...this.state.membershipCreateDataCustom,
          commitment_term: 1,
          membership_plan: {
            ...this.state.membershipCreateDataCustom.membership_plan,
            services: [],
            name: "",
            //interval_count: 0,
            active: true,
            cost: "",
            description: "",
            type: "custom",
            terms: "",
          },
        },
      });

      sessionStorage.setItem("selectedPAYID", response.json.payment_id);

      this.setState({
        selectedPaymentId: response.json.payment_id,
        payNowState: true,
        loadingCreatePreDefined: false,
      });
    }
  };

  handleSubmitCreateNewMembershipWithMemberAndPlanPayNow = async () => {
    this.setState({
      loadingCreatePreDefined: true,
    });
    // const response = await Controller.CreateMembershipnPreDefined(
    //   this.state.membershipCreateData
    // );
    const membershipCreateData = {
      ...this.state.membershipCreateData,
      send_payment_request_email: false,
    };

    const response = await Controller.CreateMembershipnPreDefined(
      membershipCreateData
    );
    if (response.status < 250) {
      this.setState({
        membershipCreateData: {
          ...this.state.membershipCreateData,
          plan: "",
        },
      });
      this.openNotification(
        "bottom",
        response.message ? response.message : "Done",
        "Successfull"
      );

      sessionStorage.setItem("selectedPAYID", response.json.payment_id);
      this.setState({
        selectedPaymentId: response.json.payment_id,
        payNowState: true,
        loadingCreatePreDefined: false,
      });
    } else {
      const errorMessage = response.json?.detail || response.message || "An unknown error occurred.";
      
      this.openNotification(
        "bottom",
        errorMessage,
        "Error"
      );

      this.setState({
        loadingCreatePreDefined: false,
      });
    }
  };
  singlePay = async () => {
    // Prevent double submit while loading
    if (this.state.permission === "loading") return;

    const pmId = this.state.selectedCardId;
    const customerId = this.state.singlePaymentData?.customer;
    const amount = this.state.singlePaymentData?.amount;

    this.setState({ permission: "loading" });

    try {
      const res = await controller.singlePay(amount, customerId, false, pmId);
      const data = res?.data ?? res;

      if (data?.status === "paid") {
        this.setState({
          isPaid: true,
          permission: "",
        });
        localStorage.setItem("transactionData", JSON.stringify(data))

        // optional redirect here
        // window.location.href = `${window.location.origin}/#/admin/success/?`;
      } else {
        console.log("payment not paid yet:", data?.status, data);
        this.setState({ permission: "error" }); // or "idle" if you prefer
      }
    } catch (error) {
      console.error("Error fetching clientSecret:", error);
      this.setState({ permission: "error" });
    }
  };

  handeSubmitSinglePayment = async () => {
    this.setState({
      paySinglePaymentState: true,
      send_payment_request_email: false,
    });
    if (this.state.selectedCardId) {
      this.singlePay();
    }

    // const response = await Controller.createSinglePayment(
    //   this.state.singlePaymentData
    // );
    // if (response.status < 250) {
    //   this.openNotification(
    //     "bottom",
    //     response.message ? response.message : "Done",
    //     "Successfull"
    //   );
    // }
    // sessionStorage.setItem("selectedPAYID", response.json.payment_id);
    // this.setState({
    //   selectedPaymentId: response.json.payment_id,
    //   paySinglePaymentState: true,
    //   loadingCreatePreDefined: false,
    // });
    // const singlePaymentData = {
    //   ...this.state.singlePaymentData,
    //   send_payment_request_email: this.state.emailPayment,
    // };
    // const response = await Controller.CreateMembershipnPreDefined(singlePaymentData);
    // const paymentId = String(response.data.payment_id);

    // if (this.state.manualPayment) {
    //   this.props.setCurrentStep("verification");
    //   this.props.setPaymentId(paymentId);
    //   return;
    // } else if (this.state.emailPayment) {
    //   if (response.status < 250) {
    //     this.openNotification(
    //       "bottom",
    //       response.message ? response.message : "Done",
    //       "Successful"
    //     );
    //   }
    //   this.setState({ loadingCreatePreDefined: false });
    // }
  };

  handleSubmitCreateNewMembershipWithMemberAndPlan = async () => {
    this.setState({
      loadingCreatePreDefined: true,
    });
    const membershipCreateData = {
      ...this.state.membershipCreateData,
      send_payment_request_email: true,
    };
    const response = await Controller.CreateMembershipnPreDefined(
      membershipCreateData
    );
    if (response.status < 250) {
      this.setState({
        membershipCreateData: {
          ...this.state.membershipCreateData,
          plan: "",
        },
      });
      this.openNotification(
        "bottom",
        response.message ? response.message : "Done",
        "Successfull"
      );
    }
    this.setState({
      loadingCreatePreDefined: false,
    });
  };

  handleCloseAddRowModal = () => {
    this.setState({
      openAddNewRowVisible: false,
      SelectedServicesFromSelectBox: null,
      SelectedCountFromSelectBox: 0,
      duration_unit: "",
      duration_value: "",
      showCreateServiceForm: false,
      isEditingExistingService: false,
      repeatType: undefined,
      createsService: { name: "", description: "", cost: "" },
      repeatCounts: { day: 1, week: 1, month: 1, year: 1 },
      expirationType: "none",
    });
  };

  addNewRowModal = async () => {
    const response = await Controller.GetServiceNP(
      this.state.currentState !== "customePlan" ? "membership" : "installment"
    );

    this.setState({
      openAddNewRowVisible: true,
      NpServices: response.json,
    });
  };

  handleSelectExistingService = (id) => {
    const svc = (this.state.NpServices || []).find((s) => s.id === id);

    const toRepeatType = (interval) => {
      if (!interval) return undefined;
      const v = String(interval).toLowerCase();
      if (v === "daily") return "day";
      if (v === "weekly") return "week";
      if (v === "monthly") return "month";
      if (v === "annual") return "year";
      return undefined;
    };

    const repeatType = toRepeatType(svc?.interval);

    const planServices =
      this.state.currentState === "customePlan"
        ? this.state.membershipCreateDataCustom?.membership_plan?.services || []
        : this.state.preDefinePlanForCreate?.services || [];

    const existingRow = planServices.find(
      (row) => String(row.service) === String(id)
    );

    const prevCount = Number(
      existingRow && existingRow.count != null ? existingRow.count : 1
    );

    const hasExpire =
      !!existingRow &&
      !!existingRow.duration_unit &&
      existingRow.duration_unit !== "";
    const expirationType = hasExpire
      ? String(existingRow.duration_unit)
      : "none";
    const duration_unit = hasExpire ? String(existingRow.duration_unit) : "";
    const duration_value = hasExpire
      ? Number(existingRow.duration_value)
      : null;

    this.setState((prev) => ({
      SelectedServicesFromSelectBox: id,
      showCreateServiceForm: true,
      isExistingService: true,
      isEditingExistingService: true,

      createsService: {
        ...prev.createsService,
        name: svc?.name ?? "",
        description: svc?.description ?? "",
        cost: svc?.cost ?? "",
        interval: svc?.interval,
        interval_count: svc?.interval_count ?? 1,
      },

      SelectedCountFromSelectBox: prevCount,
      expirationType,
      duration_unit,
      duration_value,

      repeatType: repeatType ?? prev.repeatType,
      repeatCounts: repeatType
        ? { ...prev.repeatCounts, [repeatType]: svc?.interval_count ?? 1 }
        : prev.repeatCounts,
    }));
  };

  // Map API interval -> Radio repeatType
  toRepeatType = (interval) => {
    if (!interval) return undefined;
    const v = String(interval).toLowerCase();
    if (v === "daily") return "day";
    if (v === "weekly") return "week";
    if (v === "monthly") return "month";
    if (v === "annual") return "year";
    return undefined;
  };

  editService = async () => {
    let payload = {
      id: this.state.SelectedServicesFromSelectBox,
      ...this.state.createsService,
    };

    if (!payload.name || payload.name.trim() === "") {
      Alert.openNotification("Please enter a service name", "error");
      return null;
    }
    if (
      payload.cost === "" ||
      payload.cost === null ||
      isNaN(Number(payload.cost))
    ) {
      Alert.openNotification("Please enter a valid cost", "error");
      return null;
    }

    const isInstallment = this.state.currentState === "customePlan";
    if (!isInstallment) {
      if (!payload.interval || !payload.interval_count) {
        Alert.openNotification(
          "Please set the replenish schedule (interval)",
          "error"
        );
        return null;
      }
      payload = { ...payload, type: "membership" };
    } else {
      // Ensure installment sends empty interval fields
      payload = { ...payload, interval: null, interval_count: null, type: "installment" };
    }

    payload.cost = Number(payload.cost);

    // console.log(data)
    const response = await Controller.EditService(payload);

    if (response.status < 250) {
      await this.updateServiceList();
      Alert.openNotification(
        response.message ? response.message : "Successful",
        "success"
      );
    } else {
      Alert.openNotification(
        response.json.detail ? response.json.detail : "Error",
        "error"
      );
    }
    // handleCloseEdit()
  };

  handleCreateService = async () => {
    var payload = this.state.createsService;

    if (this.state.currentState == "customePlan") {
      payload = {
        ...payload,
        interval: null,
        interval_count: null,
        type: "installment",
      };

      // delete payload.interval;
      // delete payload.interval_count;
    } else {
      payload = {
        ...payload,
        type: "membership",
      };
    }
    const response = await Controller.CreateServiceList(payload);
    console.log(response);
    if (response.status < 250) {
      this.updateServiceList();
      this.openNotification(
        "bottom",
        "Create service successful",
        "successful"
      );
      this.handleCloseAddService();
      this.setState({
        SelectedServicesFromSelectBox: response.json.id,
        createsService: {
          name: "",
          description: "",
          cost: "",
        },
      });
    } else {
      this.openNotification(
        "bottom",
        response.detail ? response.detail : "Error!",
        "Error"
      );
    }
  };

  handleCreateNewPlanPreDefined01 = async () => {
    var my_data = this.state.preDefinePlanForCreate;

    if (!this.ensurePlanHasService(my_data?.services)) {
      return;
    }

    for (var i in my_data.services) {
      if (my_data.services[i].duration_unit == null) {
        my_data.services[i].duration_unit = "";
        my_data.services[i].duration_value = "";
        my_data.services[i]["no_expire"] = true;
      } else {
        my_data.services[i]["no_expire"] = false;
      }
    }

    const response = await Controller.CreatePlan(
      my_data
      //this.state.preDefinePlanForCreate
    );
    console.log(response);
    if (response.status < 250) {
      this.setState({
        selectedServices: [],
        preDefinePlanForCreate: {
          name: "",
          interval: "",
          //interval_count: 0,
          cost: "",
          description: "",
          active: true,
          clinic: localStorage.getItem("selectedOffice"),
          type: "predefined",
          services: [
            /*{
              count: 0,
              service: 0
            }*/
          ],
          terms: "",
        },
      });
      Alert.openNotification(
        response.message ? response.message : "Successful",
        "success"
      );
      this.setState({
        membershipCreateData: {
          ...this.state.membershipCreateData,
          plan: response.json.id,
        },
        currentState: "preDefinePlan",
      });
      this.getPlan();
    } else {
      Alert.openNotification(
        response.json.detail ? response.json.detail : "Error",
        "error"
      );
    }
  };

  handleChangeCreatePlanData(e) {
    const { name, value } = e.target;
    this.setState({
      preDefinePlanForCreate: {
        ...this.state.preDefinePlanForCreate,
        [name]: value,
      },
    });
  }

  handleChange(e) {
    console.log(e.target);
    const { name, value } = e.target;
    console.log(name);
    console.log(value);
    this.setState({
      createsService: {
        ...this.state.createsService,
        [name]: value,
      },
    });
  }

  handleCreateNewPlan = () => {
    this.setState({
      currentState: "createNewPlan",
    });
    this.getPlan();
  };

  addNewRow = async () => {
    var temp = this.state.selectedServices;
    const response = await Controller.GetServiceNP();
    temp.push({
      Id: this.state.selectedServices.length,
      Name: (
        <Select
          className="inputs"
          style={{ minWidth: "100px" }}
          placeholder="Select Service"
          defaultValue={[]}
          onChange={(e, value) => {
            console.log(this.state.services);
            console.log(e);
            this.setState({
              preDefinePlanForCreate: {
                ...this.state.preDefinePlanForCreate,
                services: this.state.preDefinePlanForCreate.services.push(e),
              },
            });
          }}
        >
          {response.json.map((service) => (
            <Option key={service.id}>{service.name}</Option>
          ))}
        </Select>
      ),
      Count: (
        <InputNumber
          defaultValue={0}
          min={0}
          //max={10}
          formatter={(value) => `${value}x`}
          parser={(value) => value.replace("x", "")}
          //onChange={onChange}
        />
      ),
      Price: <p>$ 0</p>,
      Action: (
        <button
          value={this.state.selectedServices.length}
          onClick={(e) => {
            e.preventDefault();
            console.log(e.target.value);
            /*console.log(this.state.selectedServices)
            var temp = this.state.selectedServices
            console.log(temp)
            console.log(e.target.value)*/
            var temp = this.state.selectedServices.filter(
              (t) => t.Id != e.target.value
            );
            if (temp.length < 1) {
              this.setState({
                selectedServices: [],
              });
            } else {
              console.log(temp);
              this.setState({
                selectedServices: temp,
              });
            }
          }}
          style={{
            border: "0px",
            backgroundColor: "transparent",
            color: "#0981C8",
          }}
        >
          Delete
        </button>
      ),
    });

    this.setState({
      selectedServices: temp,
      changeStateTempForTestTableUpdate:
        !this.state.changeStateTempForTestTableUpdate,
    });
  };

  handleChangeCurrentState = (e) => {
    this.setState({ currentState: e.target.value });
    this.getPlan();
  };

  handleOpenAddService = () => {
    this.setState({
      visibleAddservice: true,
    });
  };
  handleCloseAddService = () => {
    this.setState({
      createsService: {
        name: "",
        description: "",
        cost: "",
      },
      visibleAddservice: false,
    });
  };

  handleDateChange(value, dateString) {
    this.setState({
      ...this.state,
      appointment_datetime: dateString,
    });
  }

  handleMenuClick(e) {
    this.setState({
      ...this.state,
      reason: e.item.props.children[1],
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentState !== this.state.currentState) {
      console.log("New value:", this.state.currentState);

      if (this.state.currentState == "preDefinePlan") {
        this.setState({
          membershipCreateDataCustom: {
            ...this.state.membershipCreateDataCustom,
            membership: {
              ...this.state.membershipCreateDataCustom.membership,
              automatic_renewal: true,
            },
          },
          membershipCreateData: {
            ...this.state.membershipCreateData,
            automatic_renewal: true,
          },
        });
      } else {
        this.setState({
          membershipCreateDataCustom: {
            ...this.state.membershipCreateDataCustom,
            membership: {
              ...this.state.membershipCreateDataCustom.membership,
              automatic_renewal: false,
            },
          },
          membershipCreateData: {
            ...this.state.membershipCreateData,
            automatic_renewal: false,
          },
          singlePaymentData: {
            ...this.state.singlePaymentData,
          },
        });
      }
    }
  }

  onSearch = (value) => {
    // Filter membersList based on search input
    const filteredMembers = this.state.membersList.filter((member) => {
      const searchText = value.toLowerCase();
      return (
        (member.first_name &&
          member.first_name.toLowerCase().includes(searchText)) ||
        (member.last_name &&
          member.last_name.toLowerCase().includes(searchText)) ||
        (member.email && member.email.toLowerCase().includes(searchText)) ||
        (member.phone && member.phone.toLowerCase().includes(searchText)) ||
        (member.business_name &&
          member.business_name.toLowerCase().includes(searchText)) ||
        (member.id && member.id.toString().includes(searchText))
      );
    });

    console.log(filteredMembers);

    // Update state with filtered members
    this.setState({
      filteredMembersList: filteredMembers,
    });
  };
  componentDidMount() {
    // After fetching membersList
    this.setState({ filteredMembersList: this.state.membersList });
  }
  render() {
    console.log("adfsdf", this.state.singlePaymentData);
    console.log("selected", this.state.selectedCardId);
    //const { currentState } = this.state;
    const { profileSummary } = this.props;

    const readOnlyExisting =
      this.state.showCreateServiceForm &&
      this.state.isEditingExistingService === true;

    return this.state.payNowState ? (
      <>
        <Payment PaymentID={this.state.selectedPaymentId} />
      </>
    ) : this.state.paySinglePaymentState && !this.state.selectedCardId ? (
      <div className="paymentRequestContent" style={{ width: "100%" }}>
        <App
          amount={this.state.singlePaymentData.amount}
          customer={this.state.singlePaymentData.customer}
          send_payment_request_email={this.state.send_payment_request_email}
        />
      </div>
    ) : this.state.isPaid ? (
      <Success />
    ) : (
      // <></>
      <div className="paymentRequestContent" style={{ width: "100%" }}>
        {this.state.permission == "loading" ? (
          <div className="payreq-container">
            <div className="content" style={{ textAlign: "center" }}>
              <Spin />
            </div>
          </div>
        ) : !this.state.permission && 1 != 1 ? (
          <div className="payreq-container">
            <div
              className="content"
              style={{ textAlign: "center", color: "red" }}
            >
              Please add and verify your bank account!
            </div>
          </div>
        ) : (
          <div className="payreq-container">
            <div
              className="content"
              style={{
                maxWidth:
                  this.state.currentState == "singlePayment" ? 600 : 390,
              }}
            >
              {this.state.currentState != "createNewPlan" ? (
                <React.Fragment>
                  <label
                    style={{ margin: "10px 0px 5px 0px" }}
                    className="formLabel"
                  >
                    Member
                  </label>
                  <Row type="flex" justify={"space-between"}>
                    <Col span={18}>
                      <Select
                        allowClear={true}
                        showSearch
                        style={{ width: "100%" }}
                        placeholder="Search Member"
                        optionFilterProp="children"
                        onSearch={this.onSearch} // Bind the onSearch function
                        value={
                          this.state.newCustomerid
                            ? this.state.newCustomerid
                            : this.state.membershipCreateDataCustom.membership
                                .customer
                            ? this.state.membershipCreateDataCustom.membership
                                .customer
                            : null
                        }
                        onChange={(e) => {
                          this.setState({
                            newCustomerid: "",
                            membershipCreateDataCustom: {
                              ...this.state.membershipCreateDataCustom,
                              membership: {
                                ...this.state.membershipCreateDataCustom
                                  .membership,
                                customer: e,
                              },
                            },
                            membershipCreateData: {
                              ...this.state.membershipCreateData,
                              customer: e,
                            },
                            singlePaymentData: {
                              ...this.state.singlePaymentData,
                              customer: e,
                            },
                          });
                        }}
                        filterOption={false} // Disable default filtering since we handle it in onSearch
                      >
                        <Select.OptGroup label="Members">
                          {(this.state?.filteredMembersList?.length > 0
                            ? this.state.filteredMembersList
                            : this.state.membersList
                          ).map(
                            (member0) =>
                              !member0.business_member && (
                                <Option value={member0.id} key={member0.id}>
                                  {member0.id + " "}
                                  {member0.first_name
                                    ? member0.first_name +
                                      " " +
                                      member0.last_name
                                    : member0.email
                                    ? member0.email
                                    : member0.phone}
                                </Option>
                              )
                          )}
                        </Select.OptGroup>
                        <Select.OptGroup label="Business">
                          {(this.state?.filteredMembersList?.length > 0
                            ? this.state.filteredMembersList
                            : this.state.membersList
                          ).map(
                            (member0) =>
                              member0.business_member && (
                                <Option value={member0.id} key={member0.id}>
                                  {member0.id + " "}
                                  {member0.business_name
                                    ? member0.business_name
                                    : member0.email
                                    ? member0.email
                                    : member0.phone}
                                </Option>
                              )
                          )}
                        </Select.OptGroup>
                      </Select>
                    </Col>
                    <Col span={5}>
                      <Button
                        type="primary"
                        style={{
                          height: "30px",
                          width: "100%",
                          padding: "0",
                        }}
                        onClick={this.handleAddMember}
                      >
                        + New
                      </Button>
                    </Col>
                  </Row>
                  {this.state.currentState != "singlePayment" && (
                    <>
                      <label
                        style={{ margin: "10px 0px 5px 0px" }}
                        className="formLabel"
                      >
                        Renewal
                      </label>
                      <Radio.Group
                        disabled={
                          this.state.currentState == "preDefinePlan" ||
                          this.state.currentState == "singlePayment"
                        }
                        onChange={(e) => {
                          this.setState({
                            membershipCreateDataCustom: {
                              ...this.state.membershipCreateDataCustom,
                              membership: {
                                ...this.state.membershipCreateDataCustom
                                  .membership,
                                automatic_renewal: e.target.value,
                              },
                            },
                            membershipCreateData: {
                              ...this.state.membershipCreateData,
                              automatic_renewal: e.target.value,
                            },
                          });
                        }}
                        value={
                          this.state.membershipCreateData.automatic_renewal
                        }
                      >
                        <Radio value={true}>Automatic</Radio>
                        <br />
                        <Radio value={false}>Manual</Radio>
                      </Radio.Group>
                    </>
                  )}
                  <br /> <br />
                  <Row type="flex" justify="center">
                    <Radio.Group
                      value={this.state.currentState}
                      onChange={this.handleChangeCurrentState}
                      className="responsive-radio-group"
                    >
                      <Radio.Button
                        value="preDefinePlan"
                        style={{
                          width:
                            this.state.currentState == "singlePayment"
                              ? 200
                              : "inherit",
                        }}
                      >
                        Membership Plan
                      </Radio.Button>
                      <Radio.Button
                        value="customePlan"
                        style={{
                          width:
                            this.state.currentState == "singlePayment"
                              ? 200
                              : "inherit",
                        }}
                      >
                        Installment Plan
                      </Radio.Button>
                      <Radio.Button
                        value="singlePayment"
                        style={{
                          width:
                            this.state.currentState == "singlePayment"
                              ? 200
                              : "inherit",
                        }}
                      >
                        Single Payment
                      </Radio.Button>
                    </Radio.Group>
                  </Row>
                </React.Fragment>
              ) : (
                <React.Fragment></React.Fragment>
              )}

              {
                //--------------------------------------Create custom plan --------------------------
                this.state.currentState == "customePlan" ? (
                  <React.Fragment>
                    <label
                      style={{ margin: "10px 0px 5px 0px" }}
                      className="formLabel"
                    >
                      Plan name
                    </label>
                    <Input
                      //prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                      className={"inputs"}
                      onChange={(e) => {
                        this.setState({
                          membershipCreateDataCustom: {
                            ...this.state.membershipCreateDataCustom,
                            membership_plan: {
                              ...this.state.membershipCreateDataCustom
                                .membership_plan,
                              name: e.target.value,
                            },
                          },
                        });
                      }}
                      type="text"
                      name="name"
                      placeholder="plan-1"
                      value={
                        this.state.membershipCreateDataCustom.membership_plan
                          .name
                      }
                    />

                    <label
                      style={{ margin: "10px 0px 5px 0px" }}
                      className="formLabel"
                    >
                      Billing Cycle
                    </label>
                    <Select
                      className="inputs"
                      style={{ minWidth: "100px" }}
                      defaultValue={[]}
                      placeholder="Select Cycle"
                      value={
                        this.state.membershipCreateDataCustom.membership_plan
                          .interval
                          ? this.state.membershipCreateDataCustom
                              .membership_plan.interval
                          : null
                      }
                      onChange={(e) => {
                        this.setState({
                          membershipCreateDataCustom: {
                            ...this.state.membershipCreateDataCustom,
                            membership_plan: {
                              ...this.state.membershipCreateDataCustom
                                .membership_plan,
                              interval: e,
                            },
                          },
                        });
                      }}
                    >
                      {this.state.Cycle &&
                        this.state.Cycle.map((cycle) => (
                          <>
                            <Option key={cycle}>{cycle}</Option>
                          </>
                        ))}
                    </Select>

                    {/* <label style={{ margin: "10px 0px 5px 0px" }} className='formLabel'>Interval Count</label>
                        <Input
                          prefix={<BsClockHistory style={{ color: 'rgba(0,0,0,.25)' }} />}
                          value={this.state.membershipCreateDataCustom.membership_plan.interval_count}
                          onChange={(e) => {
                            this.setState({
                              membershipCreateDataCustom: {
                                ...this.state.membershipCreateDataCustom,
                                membership_plan: {
                                  ...this.state.membershipCreateDataCustom.membership_plan,

                                  interval_count: e.target.value
                                }
                              }
                            })
                          }}
                          className={"inputs"}
                          type="text"
                          name="name"
                          placeholder="Commitment Term"
                        /> */}

                    <label
                      style={{ margin: "10px 0px 5px 0px" }}
                      className="formLabel"
                    >
                      Commitment Term
                    </label>
                    <InputNumber
                      defaultValue={0}
                      //formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                      style={{ width: "100%" }}
                      value={
                        this.state.membershipCreateDataCustom.commitment_term
                      }
                      onChange={(e) => {
                        this.setState({
                          membershipCreateDataCustom: {
                            ...this.state.membershipCreateDataCustom,
                            commitment_term: e,
                          },
                        });
                      }}
                    />

                    <label
                      style={{ margin: "10px 0px 5px 0px" }}
                      className="formLabel"
                    >
                      Price
                    </label>
                    <InputNumber
                      defaultValue={0}
                      formatter={(value) =>
                        `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                      style={{ width: "100%" }}
                      value={
                        this.state.membershipCreateDataCustom.membership_plan
                          .cost
                      }
                      onChange={(e) => {
                        this.setState({
                          membershipCreateDataCustom: {
                            ...this.state.membershipCreateDataCustom,
                            membership_plan: {
                              ...this.state.membershipCreateDataCustom
                                .membership_plan,

                              cost: e,
                            },
                          },
                        });
                      }}
                      //onChange={onChange}
                    />

                    <br />
                    <br />

                    {/*---------------------------------Add service in Create member ship---------------------------*/}
                    <Row type="flex" justify="space-between">
                      <label style={{ margin: "10px 0px 5px 0px" }}>
                        Service{" "}
                        {/*<span
                      style={{ cursor: "pointer" }}
                  onClick={this.addNewRowModal}>+</span>*/}
                      </label>
                      <Button
                        //onClick={this.handleOpenAddService}
                        onClick={
                          //this.addNewRow
                          this.addNewRowModal
                        }
                        type="primary"
                        style={{ marginBottom: 16 }}
                      >
                        + New
                      </Button>
                    </Row>
                    {this.state.changeStateTempForTestTableUpdate ? (
                      <Table
                        style={{
                          width: "auto",
                          overflow: "auto",
                        }}
                        Pagination={false}
                        columns={serviceColumns}
                        dataSource={this.state.selectedServices}
                      />
                    ) : (
                      <div>
                        <Table
                          style={{
                            width: "auto",
                            overflow: "auto",
                          }}
                          Pagination={false}
                          columns={serviceColumns}
                          dataSource={this.state.selectedServices}
                        />
                      </div>
                    )}

                    <label
                      style={{ margin: "10px 0px 5px 0px" }}
                      className="formLabel"
                    >
                      Terms
                    </label>

                    <TextArea
                      value={
                        this.state.membershipCreateDataCustom?.membership_plan
                          ?.terms
                      }
                      onChange={(e) => {
                        this.setState({
                          membershipCreateDataCustom: {
                            ...this.state.membershipCreateDataCustom,
                            membership_plan: {
                              ...this.state.membershipCreateDataCustom
                                .membership_plan,

                              terms: e.target.value,
                            },
                          },
                        });
                      }}
                      autoSize={{ minRows: 3, maxRows: 5 }}
                      placeholder="Write Terms..."
                    />

                    {/* <Button className='whiteBtn cancel-btn'
                            onClick={() => {
                              this.props.back(true)
                            }}
                          >Back</Button> */}
                    <Row
                      justify="end"
                      style={{ marginTop: "25px", padding: "8px" }}
                      gutter={[16]}
                    >
                      <Button
                        style={{ width: "100%" }}
                        onClick={this.handleCreateCustomPlan}
                        type="primary"
                      >
                        Text/E-mail
                        {/*this.state.sending_data ? "Sending ..." : "Send"*/}
                      </Button>

                      <Button
                        variant="text"
                        onClick={this.handleCreateCustomPlanPayNow}
                        style={{ width: "100%", marginTop: "8px" }}
                        type="text"
                        disabled={this.state.loadingCreatePreDefined}
                      >
                        Pay Now
                        {/*this.state.sending_data ? "Sending ..." : "Send"*/}
                      </Button>
                    </Row>
                  </React.Fragment>
                ) : /*------------------------------Create mebership-------------------------------*/
                this.state.currentState == "preDefinePlan" ? (
                  <React.Fragment>
                    <br />
                    <label
                      style={{ margin: "10px 0px 5px 0px" }}
                      className="formLabel"
                    >
                      Commitment Term
                    </label>
                    <InputNumber
                      defaultValue={0}
                      //formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                      style={{ width: "100%" }}
                      value={this.state.membershipCreateData.commitment_term}
                      onChange={(e) => {
                        this.setState({
                          membershipCreateData: {
                            ...this.state.membershipCreateData,
                            commitment_term: e,
                          },
                        });
                      }}
                    />
                    <label
                      style={{ margin: "10px 0px 5px 0px" }}
                      className="formLabel"
                    >
                      Membership Plans
                    </label>
                    <Row
                      type="flex"
                      justify={"space-between"}
                      gutter={[16]}
                      align="middle"
                    >
                      <Col span={17}>
                        <Select
                          showSearch
                          placeholder="Search Membership Plans"
                          optionFilterProp="children"
                          disabled={
                            this.state.planList.length > 0 ? false : true
                          }
                          //onChange={onChange}
                          //onFocus={onFocus}
                          //onBlur={onBlur}
                          //onSearch={onSearch}
                          style={{ width: "100%" }}
                          onChange={(e) => {
                            this.setState({
                              membershipCreateData: {
                                ...this.state.membershipCreateData,
                                plan: e,
                              },
                            });
                          }}
                          value={
                            this.state.membershipCreateData.plan
                              ? this.state.membershipCreateData.plan
                              : null
                          }
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {this.state.planList ? (
                            this.state.planList.map((plan0) => (
                              <Option value={plan0.id}>{plan0.name}</Option>
                            ))
                          ) : (
                            <></>
                          )}
                        </Select>
                      </Col>
                      <Col span={7}>
                        <Button
                          style={{ width: "100%" }}
                          onClick={this.handleCreateNewPlan}
                          type="primary"
                        >
                          +Add
                          {/*this.state.sending_data ? "Sending ..." : "Send"*/}
                        </Button>
                      </Col>
                    </Row>

                    {/* <label className='formLabel'>Terms</label>


                    <TextArea
                      //value={value}
                      //onChange={this.onChange}

                      autoSize={{ minRows: 3, maxRows: 5 }}
                      placeholder="Write Terms..."
                      />*/}
                    <Row
                      justify="end"
                      style={{ marginTop: "25px", padding: "8px" }}
                      gutter={[16]}
                    >
                      <Button
                        onClick={
                          this.handleSubmitCreateNewMembershipWithMemberAndPlan
                        }
                        style={{ width: "100%" }}
                        type="primary"
                        disabled={this.state.loadingCreatePreDefined}
                      >
                        Text/E-mail
                        {/*this.state.sending_data ? "Sending ..." : "Send"*/}
                      </Button>
                      <Button
                        variant="text"
                        onClick={
                          this
                            .handleSubmitCreateNewMembershipWithMemberAndPlanPayNow
                        }
                        style={{ width: "100%", marginTop: "8px" }}
                        type="text"
                        disabled={this.state.loadingCreatePreDefined}
                      >
                        Pay Now
                        {/*this.state.sending_data ? "Sending ..." : "Send"*/}
                      </Button>
                    </Row>
                    {/* <Row justify="end" style={{ padding: "8px" }} gutter={[16]}>
                            <Button
                              style={{ width: "100%" }}
                              onClick={() => {
                                this.setState({
                                  currentState: "preDefinePlan"
                                })
                                this.getPlan()
                              }}
                            >Back</Button>
                          </Row> */}
                  </React.Fragment>
                ) : //--------------------------------------Single Payment --------------------------
                this.state.currentState == "singlePayment" ? (
                  <React.Fragment>
                    <br />
                    <Row
                      justify="start"
                      style={{ marginBottom: "25px", padding: "8px" }}
                      gutter={[16]}
                    >
                      <label
                        style={{ margin: "10px 0px 5px 0px" }}
                        className="formLabel"
                      >
                        Price
                      </label>
                      <InputNumber
                        defaultValue={0}
                        formatter={(value) =>
                          `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                        parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                        style={{ width: "100%" }}
                        value={this.state.singlePaymentData.amount}
                        onChange={(e) => {
                          this.setState({
                            singlePaymentData: {
                              ...this.state.singlePaymentData,
                              amount: e,
                            },
                          });
                        }}
                      />
                      {this.state.singlePaymentData?.customer && (
                        <Col span={24} style={{ marginTop: "20px" }}>
                          <Card style={{ width: "100%" }}>
                            <MemberCardsCarousel
                              title="Member Cards"
                              loading={false}
                              memberId={this.state.singlePaymentData?.customer}
                              onCardSelected={this.handleCardSelection}
                            />
                          </Card>
                        </Col>
                      )}
                      <br />
                      <br />
                      {/* <Button
                        onClick={this.handeSubmitSinglePayment}
                        style={{ width: "100%", marginTop: "25px" }}
                        type="primary"
                        disabled={this.state.loadingCreatePreDefined}
                      >
                        {this.state.loadingCreatePreDefined
                          ? "Creating..."
                          : "Create"}

                        {/*this.state.sending_data ? "Sending ..." : "Send"*/}
                      {/* </Button> */}
                      <Button
                        variant="text"
                        onClick={this.handeSubmitSinglePayment}
                        style={{ width: "100%", marginTop: "14px" }}
                        type="primary"
                        disabled={this.state.loadingCreatePreDefined}
                      >
                        Pay Now
                        {/*this.state.sending_data ? "Sending ..." : "Send"*/}
                      </Button>
                    </Row>
                    {/* <Row justify="end" style={{ padding: "8px" }} gutter={[16]}>
                                          <Button
                                            style={{ width: "100%" }}
                                            onClick={() => {
                                              this.setState({
                                                currentState: "preDefinePlan"
                                              })
                                              this.getPlan()
                                            }}
                                          >Back</Button>
                                        </Row> */}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <label
                      style={{ margin: "10px 0px 5px 0px" }}
                      className="formLabel"
                    >
                      Plan name
                    </label>
                    <Input
                      //prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                      className={"inputs"}
                      onChange={this.handleChangeCreatePlanData}
                      type="text"
                      name="name"
                      placeholder="plan #1"
                      value={this.state.preDefinePlanForCreate.name}
                    />

                    <label
                      style={{ margin: "10px 0px 5px 0px" }}
                      className="formLabel"
                    >
                      Billing Cycle
                    </label>
                    <Select
                      className="inputs"
                      style={{ minWidth: "100px" }}
                      defaultValue={[]}
                      placeholder="Select Cycle"
                      name="interval"
                      value={
                        this.state.preDefinePlanForCreate.interval
                          ? this.state.preDefinePlanForCreate.interval
                          : null
                      }
                      onChange={(e, value) => {
                        this.setState({
                          preDefinePlanForCreate: {
                            ...this.state.preDefinePlanForCreate,
                            interval: e,
                          },
                        });
                      }}
                    >
                      {this.state.Cycle &&
                        this.state.Cycle.map((cycle) => (
                          <>
                            <Option key={cycle}>{cycle}</Option>
                          </>
                        ))}
                    </Select>

                    {/* <label style={{ margin: "10px 0px 5px 0px" }} className='formLabel'>Interval Count</label>
                          <Input
                            prefix={<BsClockHistory style={{ color: 'rgba(0,0,0,.25)' }} />}
                            name="interval_count"
                            className={"inputs"}
                            onChange={this.handleChangeCreatePlanData}
                            type="text"

                            placeholder="Interval Count"
                            value={this.state.preDefinePlanForCreate.interval_count}
                          /> */}

                    <label
                      style={{ margin: "10px 0px 5px 0px" }}
                      className="formLabel"
                    >
                      Price
                    </label>
                    <InputNumber
                      value={this.state.preDefinePlanForCreate.cost}
                      defaultValue={0}
                      formatter={(value) =>
                        `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                      style={{ width: "100%" }}
                      onChange={(e) => {
                        this.setState({
                          preDefinePlanForCreate: {
                            ...this.state.preDefinePlanForCreate,
                            cost: e,
                          },
                        });
                      }}
                    />

                    <br />
                    <br />
                    <Row type="flex" justify="space-between">
                      <label>
                        Service{" "}
                        {/*<span
                        style={{ cursor: "pointer" }}
                        onClick={
                          //this.addNewRow
                          this.addNewRowModal
                        }>+</span>*/}
                      </label>
                      <Button
                        //onClick={this.handleOpenAddService}
                        onClick={
                          //this.addNewRow
                          this.addNewRowModal
                        }
                        type="primary"
                        style={{ marginBottom: 16 }}
                      >
                        + New
                      </Button>
                    </Row>
                    {this.state.changeStateTempForTestTableUpdate ? (
                      <Table
                        style={{
                          width: "auto",
                          overflow: "auto",
                        }}
                        Pagination={false}
                        columns={serviceColumns}
                        dataSource={this.state.selectedServices}
                      />
                    ) : (
                      <div>
                        <Table
                          style={{
                            width: "auto",
                            overflow: "auto",
                          }}
                          Pagination={false}
                          columns={serviceColumns}
                          dataSource={this.state.selectedServices}
                        />
                      </div>
                    )}

                    <label
                      style={{ margin: "10px 0px 5px 0px" }}
                      className="formLabel"
                    >
                      Terms
                    </label>

                    <TextArea
                      name="terms"
                      value={this.state.preDefinePlanForCreate.terms}
                      onChange={(e) => {
                        //console.log(e.target.value)
                        this.setState({
                          preDefinePlanForCreate: {
                            ...this.state.preDefinePlanForCreate,
                            terms: e.target.value,
                          },
                        });
                      }}
                      autoSize={{ minRows: 3, maxRows: 5 }}
                      placeholder="Write Terms..."
                    />

                    <Row
                      justify="end"
                      style={{ marginTop: "25px", padding: "8px" }}
                      gutter={[16]}
                    >
                      {/* <button className='whiteBtn cancel-btn'
                              onClick={() => {
                                this.setState({
                                  currentState: "preDefinePlan"
                                })
                                this.getPlan()
                              }}
                            >Back</button> */}

                      <Button
                        onClick={this.handleCreateNewPlanPreDefined01}
                        style={{ width: "100%" }}
                        type="primary"
                      >
                        Create
                        {/*this.state.sending_data ? "Sending ..." : "Send"*/}
                      </Button>
                    </Row>
                    <Row justify="end" style={{ padding: "8px" }} gutter={[16]}>
                      <Button
                        style={{ width: "100%" }}
                        onClick={() => {
                          this.setState({
                            currentState: "preDefinePlan",
                          });
                          this.getPlan();
                        }}
                      >
                        Back
                      </Button>
                    </Row>
                  </React.Fragment>
                )
              }
              <br />
            </div>
          </div>
        )}

        {/*---------------------------Add new service-------------------------*/}
        <Modal
          title={"Add new service"}
          visible={this.state.openAddNewRowVisible}
          footer={null}
          onCancel={this.handleCloseAddRowModal}
        >
          {!this.state.showCreateServiceForm && (
            <>
              <label className="formLabel">Service</label>
              <Row justify="space-between">
                <Col span={18}>
                  <Select
                    className="inputs"
                    style={{ minWidth: "100px" }}
                    placeholder="Select Service"
                    value={this.state.SelectedServicesFromSelectBox}
                    onChange={this.handleSelectExistingService}
                  >
                    {this.state.NpServices &&
                      this.state.NpServices.length > 0 &&
                      this.state.NpServices.map((service) => (
                        <Option value={service.id} key={service.id}>
                          {service.name}
                        </Option>
                      ))}
                  </Select>
                </Col>
                <Col span={5}>
                  <Button
                    onClick={() =>
                      this.setState((prev) => ({
                        showCreateServiceForm: true,
                        isEditingExistingService: false,
                        isExistingService: false,
                        repeatType: "month",

                        createsService: {
                          name: "",
                          description: "",
                          cost: 0,
                          interval: this.mapRepeatTypeToInterval("month"), // "Monthly"
                          interval_count: prev.repeatCounts?.month ?? 1,
                        },

                        SelectedCountFromSelectBox: 1,
                        expirationType: "none",
                        duration_unit: "",
                        duration_value: null,
                      }))
                    }
                    type="primary"
                    style={{ marginBottom: 16 }}
                  >
                    Add Service
                  </Button>
                </Col>
              </Row>
            </>
          )}

          {this.state.showCreateServiceForm && (
            <>
              <label
                style={{ margin: "10px 0px 5px 0px" }}
                className="formLabel"
              >
                Service Name
              </label>
              <Input
                className={"inputs"}
                onChange={this.handleChange}
                type="text"
                name="name"
                placeholder="Service 1"
                value={this.state.createsService.name}
                disabled={readOnlyExisting}
              />

              <label className="formLabel">Count</label>
              <InputNumber
                style={{ width: "100%" }}
                min={0}
                value={this.state.SelectedCountFromSelectBox}
                formatter={(value) => `${value}x`}
                parser={(value) => value.replace("x", "")}
                onChange={(value) =>
                  this.setState({ SelectedCountFromSelectBox: value })
                }
              />

              {/* <label
                style={{ margin: "10px 0px 5px 0px" }}
                className="formLabel"
              >
                Cost
              </label>
              <InputNumber
                value={this.state.createsService.cost}
                name="cost"
                defaultValue={0}
                disabled={readOnlyExisting}
                formatter={(value) =>
                  `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                style={{ width: "100%" }}
                onChange={(e) => {
                  this.setState({
                    createsService: {
                      ...this.state.createsService,
                      cost: e,
                    },
                  });
                }}
              /> */}

              {this.state.currentState !== "customePlan" && (
              <>
                {/* Replaced Billing Interval with Radio Group */}
                <label className="formLabel" style={{ marginTop: 10 }}>
                  Services Will Be Replenished:
                </label>
                <div style={{ margin: "10px 0" }}>
                  <Radio.Group
                    value={this.state.repeatType}
                    disabled={readOnlyExisting}
                    onChange={(e) => {
                      const newType = e.target.value;
                      this.setState({
                        repeatType: newType,
                        createsService: {
                          ...this.state.createsService,
                          interval: this.mapRepeatTypeToInterval(newType),
                          interval_count: this.state.repeatCounts[newType],
                        },
                      });
                    }}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <Radio
                      value="day"
                      style={{ marginBottom: 8, alignItems: "center" }}
                    >
                      Every{" "}
                      <InputNumber
                        min={1}
                        value={this.state.repeatCounts.day}
                        onChange={(value) =>
                          this.handleRepeatCountChange("day", value)
                        }
                        bordered={false}
                        controls={false}
                        disabled={
                          this.state.repeatType !== "day" || readOnlyExisting
                        }
                        style={{
                          width: "70px",
                          textAlign: "center",
                          borderBottom: "1px solid #000",
                          background: "transparent",
                          padding: 0,
                        }}
                      />{" "}
                      day
                    </Radio>

                    <Radio
                      value="week"
                      style={{ marginBottom: 8, alignItems: "center" }}
                    >
                      Every{" "}
                      <InputNumber
                        min={1}
                        value={this.state.repeatCounts.week}
                        onChange={(value) =>
                          this.handleRepeatCountChange("week", value)
                        }
                        bordered={false}
                        controls={false}
                        disabled={
                          this.state.repeatType !== "week" || readOnlyExisting
                        }
                        style={{
                          width: "70px",
                          textAlign: "center",
                          borderBottom: "1px solid #000",
                          background: "transparent",
                          padding: 0,
                        }}
                      />{" "}
                      week
                    </Radio>

                    <Radio
                      value="month"
                      style={{ marginBottom: 8, alignItems: "center" }}
                    >
                      Every{" "}
                      <InputNumber
                        min={1}
                        value={this.state.repeatCounts.month}
                        onChange={(value) =>
                          this.handleRepeatCountChange("month", value)
                        }
                        bordered={false}
                        controls={false}
                        disabled={
                          this.state.repeatType !== "month" || readOnlyExisting
                        }
                        style={{
                          width: "70px",
                          textAlign: "center",
                          borderBottom: "1px solid #000",
                          background: "transparent",
                          padding: 0,
                        }}
                      />{" "}
                      month
                    </Radio>

                    <Radio
                      value="year"
                      style={{ marginBottom: 8, alignItems: "center" }}
                    >
                      Every{" "}
                      <InputNumber
                        min={1}
                        value={this.state.repeatCounts.year}
                        onChange={(value) =>
                          this.handleRepeatCountChange("year", value)
                        }
                        bordered={false}
                        controls={false}
                        disabled={
                          this.state.repeatType !== "year" || readOnlyExisting
                        }
                        style={{
                          width: "70px",
                          textAlign: "center",
                          borderBottom: "1px solid #000",
                          background: "transparent",
                          padding: 0,
                        }}
                      />{" "}
                      year
                    </Radio>
                  </Radio.Group>
                </div>
              </>
              )}

              <br />
              {this.state.currentState !== "customePlan" && (
                <>
                  <label
                    style={{ margin: "10px 0px 5px 0px" }}
                    className="formLabel"
                  >
                    Service Expiration
                  </label>
                  <Radio.Group
                    value={this.state.expirationType}
                    onChange={(e) => {
                      const newType = e.target.value;
                      this.setState({
                        expirationType: newType,
                        duration_value:
                          newType === "none" ? null : this.state.duration_value,
                      });
                    }}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    {["none", "day", "month", "year"].map((type) => (
                      <Radio
                        key={type}
                        value={type}
                        style={{
                          marginBottom: 8,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {type === "none" ? (
                          "No expiration date"
                        ) : (
                          <>
                            Expire after{" "}
                            <InputNumber
                              min={1}
                              value={this.state.duration_value}
                              onChange={(value) =>
                                this.setState({
                                  duration_value: value,
                                  duration_unit: type,
                                })
                              }
                              // disabled={this.state.expirationType !== type}
                              style={{
                                width: "70px",
                                margin: "0 5px",
                                textAlign: "center",
                                borderBottom:
                                  this.state.expirationType === type
                                    ? "1px solid #000"
                                    : "none",
                                background: "transparent",
                              }}
                              bordered={false}
                              controls={false}
                            />{" "}
                            {type}(s)
                          </>
                        )}
                      </Radio>
                    ))}
                  </Radio.Group>
                </>
              )}

              <>
                <label
                  style={{ margin: "10px 0px 5px 0px" }}
                  className="formLabel"
                >
                  Description
                </label>
                <TextArea
                  name="description"
                  disabled={readOnlyExisting}
                  value={this.state.createsService.description}
                  onChange={this.handleChange}
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  placeholder="Description..."
                />
              </>

              {/* <div
                className="btnBox"
                style={{ display: "flex", justifyContent: "end" }}
              >
                <Button
                  onClick={() =>
                    this.setState({
                      showCreateServiceForm: false,
                      ...(this.state.isEditingExistingService
                        ? {}
                        : { SelectedServicesFromSelectBox: null }),
                    })
                  }
                  type="text"
                >
                  Close
                </Button>
              </div> */}
            </>
          )}

          <div
            style={{
              marginTop: "15px",
              display: "flex",
              justifyContent: "end",
            }}
          >
            <Button onClick={this.handleCloseAddRowModal}>Close</Button>
            <Button
              type="primary"
              style={{ marginLeft: "5px" }}
              disabled={
                !this.state.SelectedServicesFromSelectBox &&
                !this.state.showCreateServiceForm
              }
              onClick={async () => {
                const createdNameFallback = this.state.createsService?.name;
                // If the inline form is open, ensure the service exists/updated before attaching
                if (this.state.showCreateServiceForm) {
                  if (this.state.isExistingService) {
                    // Edit existing service
                    await this.editService();
                  } else {
                    // Create brand-new service if no id selected yet
                    if (!this.state.SelectedServicesFromSelectBox) {
                      await this.handleCreateService();
                      // handleCreateService() sets SelectedServicesFromSelectBox and updates list
                    }
                  }
                }

                // Prepare expiration fields
                const { expirationType, duration_unit, duration_value } =
                  this.state;
                const durationUnit =
                  expirationType === "none" ? null : duration_unit;
                const durationValue =
                  expirationType === "none" ? null : duration_value;

                // Resolve selected service id
                const selectedServiceId =
                  this.state.SelectedServicesFromSelectBox;
                if (!selectedServiceId) {
                  // No service to attach
                  return;
                }

                const selectedInList =
                  (this.state.NpServices || []).find(
                    (s) => String(s.id) === String(selectedServiceId)
                  ) || null;

                // Duplicate protection
                const alreadyExists = (this.state.selectedServices || []).some(
                  (s) => String(s.id) === String(selectedServiceId)
                );

                // If we were editing and it's already attached, just close the modal
                if (alreadyExists && this.state.isEditingExistingService) {
                  this.handleCloseAddRowModal();
                  return;
                }

                if (alreadyExists && !this.state.isEditingExistingService) {
                  Alert.openNotification(
                    "This service is already available in the list",
                    "error"
                  );
                  return;
                }

                // Build payloads and attach
                const newServiceData = {
                  count: this.state.SelectedCountFromSelectBox,
                  service: selectedServiceId,
                  duration_unit: durationUnit,
                  duration_value: durationValue,
                };

                const newTableRow = {
                  id: selectedServiceId,
                  Name: selectedInList
                    ? selectedInList.name
                    : createdNameFallback || "Service",
                  Count: this.state.SelectedCountFromSelectBox,
                  DurationUnit: durationUnit,
                  DurationValue: durationValue,
                  Action: (
                    <button
                      onClick={() => {
                        const updatedSelected = (
                          this.state.selectedServices || []
                        ).filter(
                          (e) => String(e.id) !== String(selectedServiceId)
                        );
                        const updatedPreDefine = (
                          this.state.preDefinePlanForCreate.services || []
                        ).filter(
                          (e) => String(e.service) !== String(selectedServiceId)
                        );
                        this.setState({
                          selectedServices: updatedSelected,
                          preDefinePlanForCreate: {
                            ...this.state.preDefinePlanForCreate,
                            services: updatedPreDefine,
                          },
                        });
                      }}
                      style={{
                        border: "0px",
                        backgroundColor: "transparent",
                        color: "#0981C8",
                      }}
                    >
                      Delete
                    </button>
                  ),
                };

                this.setState((prev) => ({
                  preDefinePlanForCreate: {
                    ...prev.preDefinePlanForCreate,
                    services: [
                      ...prev.preDefinePlanForCreate.services,
                      newServiceData,
                    ],
                  },
                  membershipCreateDataCustom: {
                    ...prev.membershipCreateDataCustom,
                    membership_plan: {
                      ...prev.membershipCreateDataCustom.membership_plan,
                      services: [
                        ...prev.preDefinePlanForCreate.services,
                        newServiceData,
                      ],
                    },
                  },
                  selectedServices: [...prev.selectedServices, newTableRow],
                  changeStateTempForTestTableUpdate:
                    !prev.changeStateTempForTestTableUpdate,
                }));

                // Close modal
                this.handleCloseAddRowModal();
              }}
            >
              Save
            </Button>
          </div>
        </Modal>
        {/* <Modal
          title="Create New Service"
          open={this.state.visibleAddservice}
          footer={null}
          onCancel={this.handleCloseAddService}
        >
         
        </Modal> */}

        <CreateMember
          open={this.state.openCreateMember}
          handleAddNewMember={this.handleAddNewMember}
          handleCloseMember={this.handleCloseMember}
        />
      </div>
    );
  }
}

export default CreatePlan;
